import request from "root/js/request";

export const getWBDynamicBrandColors = async ({
  brand_ids,
  seller_ids,
  product_ids,
  date_from,
  date_to,
  extra_fields,
  offset,
  limit,
  ordering,
}) => {
  const response = await request({
    url: `/wb_dynamic/brand_colors/`,
    method: "get",
    params: {
      brand_ids,
      seller_ids,
      product_ids,
      date_from,
      date_to,
      extra_fields,
      offset,
      limit,
      ordering,
    },
  });
  return response.data;
};
